/* eslint-disable no-param-reassign */
/* eslint-disable no-unreachable */
/* eslint-disable no-confusing-arrow */
/* eslint-disable object-shorthand */
/* eslint-disable jsdoc/require-param */
/* eslint-disable no-else-return */
import React, { useState, useEffect } from "react";
import { CircularProgress, Typography, Button } from "@material-ui/core";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { useSB } from "../../contexts/SupabaseContext";
import { useCompany } from "../../contexts/CompanyContext";
import { supabase } from "../../supabase";
import { useAuth } from "../../contexts/AuthContext";

/**
 * SelectSuppliers is a React component that manages the selection of product types and suppliers
 * for a dealer. It filters available product types and suppliers based on the dealer's parent
 * and current user's permissions. It provides checkboxes for selecting product types and suppliers,
 * and triggers change handlers to update the selected states in the parent component.
 *
 * @param {object} props - The component props.
 * @param {Array} props.products - List of products.
 * @param {Array} props.suppliers - List of suppliers.
 * @param {Array} props.productTypes - List of available product types.
 * @param {object} props.dealerState - State object representing the dealer being edited.
 * @param {Function} props.onChangeProductTypes - Handler to update selected product types.
 * @param {Function} props.onChangeSuppliers - Handler to update selected suppliers.
 * @param {boolean} props.editing - Flag indicating if the component is in editing mode.
 * @param {object} props.currentUser - Current user details including permissions.
 * @param {Function} props.setParentSelectedSuppliersState - Function to set parent dealer's selected suppliers.
 */
/**
 * SelectSuppliers component allows users to select product types and suppliers
 * based on the current dealer's and their parent's configurations.
 *
 * @param {object} props - The component props.
 * @param {number} props.userId - The ID of the current user.
 * @param {Function} props.onClose - Callback function to handle closing the component.
 *
 * @returns {React.Element} - The rendered component.
 */
export default function SelectSuppliers(props) {
  const { userId, onClose } = props;

  const [loading, setLoading] = useState(false);
  const { GetTableWhere } = useSB();
  const { activeSuppliers, productTypes, productTypesSuppliers } = useCompany();
  const { currentUser } = useAuth();

  // Product Type States,
  const [currentDealerProductTypes, setCurrentDealerProductTypes] = useState(
    []
  );
  // Supplier States
  const [currentDealerSuppliers, setCurrentDealerSuppliers] = useState([]);

  // filteredProductTypes is the product types that are available to the dealer based on their parent.
  const [filteredProductTypes, setFilteredProductTypes] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(async () => {
    // I need product type in the supplier list

    // console.log(products, "PRODUCTS...");

    setLoading(true);

    // Is the current user an admin?
    const isAdmin = currentUser.is_admin;

    // Add the product_type_id to the supplier;

    const updatedSupplierArray = [];

    activeSuppliers.forEach(supplier => {
      supplier.product_type_ids = [];
      productTypesSuppliers.forEach(ptSupplier => {
        if (ptSupplier.suppliers_master_id === supplier.id) {
          supplier.product_type_ids.push(ptSupplier.refs_product_type_id);
        }
      });
      updatedSupplierArray.push(supplier);
    });

    if (isAdmin || currentUser?.is_leader) {
      // Set the list to show all the product types
      setFilteredProductTypes(productTypes);

      // Set the list to show all the active suppliers.
      // setFilteredSuppliers(updatedSupplierArray);
    } else {
      // Get the suppliers and product types of the parent.
      setFilteredProductTypes([]);
      setFilteredSuppliers([]);
    }

    // Find the product types associated with the selected dealer.
    const dealerProductTypes = await GetTableWhere("users_product_type_index", [
      "user_id",
      "eq",
      userId,
    ]);

    const dealerProductTypeIds = dealerProductTypes.map(
      pt => pt.product_type_id
    );

    setCurrentDealerProductTypes(dealerProductTypeIds);

    const filteredSupplierArray = updatedSupplierArray.filter(supplier =>
      supplier.product_type_ids.some(id => dealerProductTypeIds.includes(id))
    );
    // Filter updatedSupplierArray to only show items where the id of updatedSupplierArray items are in the product_type_ids array which is a property of the items in updatedSupplierArray

    setFilteredSuppliers(filteredSupplierArray);

    // Find the suppliers associated with the dealer.
    const dealerSuppliers = await GetTableWhere("users_supplier_index", [
      "user_id",
      "eq",
      userId,
    ]);

    const dealerSupplierIds = dealerSuppliers.map(
      supplier => supplier.supplier_id
    );

    setCurrentDealerSuppliers(dealerSupplierIds);

    setLoading(false);
  }, []);

  useEffect(() => {
    const filteredActiveSuppliers = activeSuppliers.filter(supplier =>
      supplier.product_type_ids.some(id =>
        currentDealerProductTypes.includes(id)
      )
    );

    setFilteredSuppliers(filteredActiveSuppliers);
  }, [currentDealerProductTypes]);

  /**
   * This function will handle the change in product types.
   * It will update the currentDealerProductTypes state based on the checkbox value.
   * @param {object} event - The event object.
   * @returns {Function} - The function to be called when the product type is changed.
   */
  const handleProductTypeChange = event => {
    const typeId = parseInt(event.target.value); // Get the checkbox value as integer
    const isChecked = event.target.checked; // Check if checkbox is checked or unchecked

    // // Update the state based on whether checkbox is checked or unchecked
    setCurrentDealerProductTypes(prevTypes => {
      if (isChecked) {
        // Add the typeId if it's checked and not already in the array
        return prevTypes.includes(typeId) ? prevTypes : [...prevTypes, typeId];
      } else {
        // Remove the typeId if it's unchecked
        return prevTypes.filter(id => id !== typeId);
      }
    });
  };

  /**
   * This function will toggle a supplier in the selectedSuppliers array.
   * If the supplier is already in the array, it will be removed.
   * If the supplier is not in the array, it will be added.
   * @returns {Function} - The function to be called when the supplier is toggled.
   */
  const handleSupplierChange = event => {
    const supplierId = parseInt(event.target.value);
    const isChecked = event.target.checked;

    setCurrentDealerSuppliers(prevSupplier => {
      if (isChecked) {
        return prevSupplier.includes(supplierId)
          ? prevSupplier
          : [...prevSupplier, supplierId];
      } else {
        // Remove the supplierId if it's unchecked
        return prevSupplier.filter(id => id !== supplierId);
      }
    });
  };

  const saveSelection = async () => {
    setSaving(true);
    const { error: deleteError } = await supabase
      .schema(process.env.REACT_APP_SB_SCHEMA)
      .from("users_supplier_index")
      .delete()
      .eq("user_id", userId);

    if (deleteError) {
      console.error("Error deleting records:", deleteError);
      return;
    }

    // Add new records to the table
    if (currentDealerSuppliers.length > 0) {
      const preparedSuppliers = currentDealerSuppliers.map(supplierId => {
        return {
          user_id: userId,
          supplier_id: supplierId,
          created_at: new Date(),
        };
      });

      const { error: insertError } = await supabase
        .schema(process.env.REACT_APP_SB_SCHEMA)
        .from("users_supplier_index")
        .insert(preparedSuppliers);

      if (insertError) {
        console.error("Error inserting new records:", insertError);
        return;
      }
    }

    // Delete the existing product types
    const { error: deleteErrorProductTypes } = await supabase
      .schema(process.env.REACT_APP_SB_SCHEMA)
      .from("users_product_type_index")
      .delete()
      .eq("user_id", userId);

    if (deleteErrorProductTypes) {
      console.error("Error deleting records:", deleteErrorProductTypes);
      return;
    }

    // Add new records to the table
    if (currentDealerProductTypes.length > 0) {
      const preparedProductTypes = currentDealerProductTypes.map(typeId => {
        return {
          user_id: userId,
          product_type_id: typeId,
          created_at: new Date(),
        };
      });
      const { error: insertErrorProductTypes } = await supabase
        .schema(process.env.REACT_APP_SB_SCHEMA)
        .from("users_product_type_index")
        .insert(preparedProductTypes);

      if (insertErrorProductTypes) {
        console.error("Error inserting new records:", insertErrorProductTypes);
        return;
      }
    }
    setSaving(false);
    onClose();
  };

  return (
    <div>
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <>
          <div>
            <Typography style={{ fontWeight: "bold" }}>
              Select Product Types:
            </Typography>
            <br />
            {/* {filteredProductTypes.length === 0 && (
              <div>
                {!dealer.parent_id ? (
                  <Typography>
                    Please select a parent before selecting a supplier.
                  </Typography>
                ) : (
                  <Typography>
                    Parent Dealer does not have any product types selected.
                  </Typography>
                )}
              </div>
            )} */}
            {filteredProductTypes.map(type => (
              <div
                style={{
                  marginLeft: 10,
                }}
              >
                <FormControlLabel
                  key={type.id}
                  control={
                    <Checkbox
                      checked={currentDealerProductTypes?.includes(
                        parseInt(type.id)
                      )}
                      onChange={handleProductTypeChange}
                      value={type.id}
                    />
                  }
                  label={type.name}
                />
              </div>
            ))}
          </div>
          <div style={styles.inputContainer}>
            <Typography style={{ fontWeight: "bold" }}>
              Select Suppliers:
            </Typography>
            <br />
            {filteredSuppliers.length === 0 && (
              <Typography>
                Please select a product type before selecting a supplier.
              </Typography>
            )}

            {filteredSuppliers &&
              filteredSuppliers.map(supplier => (
                <div
                  style={{
                    marginLeft: 10,
                  }}
                >
                  <FormControlLabel
                    key={supplier.id}
                    control={
                      <Checkbox
                        checked={currentDealerSuppliers.includes(
                          parseInt(supplier.id)
                        )}
                        onChange={handleSupplierChange}
                        value={supplier.id}
                        color="primary"
                      />
                    }
                    label={supplier.supplier_name}
                  />
                </div>
              ))}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: 20,
                width: "100%",
              }}
            >
              <Button
                disabled={loading || saving}
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => {
                  saveSelection();
                }}
              >
                {saving ? "Saving..." : "Save Selection"}
              </Button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  inputContainer: {
    marginTop: 30,
  },
};
